<template>
    <div>
        <app-section>

            <heading
                :header="page.heading"
            />

            <section-list
                type="work"
                class="p-works__list"
            />

        </app-section>

        <builder :builder="page.builder" />

        <push />

    </div>
</template>

<script>

import AppSection from 'layout/AppSection';
import Push from 'components/Push';
import Heading from 'components/Heading';
import SectionList from 'components/SectionList';
import Builder from 'builder/Builder';

export default {
    name: 'Works',
    components: {
        AppSection,
        Push,
        Heading,
        SectionList,
        Builder,
    },
    props: {
        page: Object,
    },
    metaInfo() {
        return {
            title: this.page.seo.title
        }
    },
};

</script>

<style lang="scss">

.p-works {}

.p-works__list {
    margin-top: var(--main-padding);
}

</style>
